import { render, staticRenderFns } from "./customerkeyperson.vue?vue&type=template&id=11ac7442"
import script from "./customerkeyperson.vue?vue&type=script&lang=js"
export * from "./customerkeyperson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports